<template>
	<div id="orderListComponent">
		<div v-show="loadingOrders == true">
			<mensagge-loading-component class="bg-aasinet text-white" text="Buscando Titulo">
			</mensagge-loading-component>
		</div>
		<div class="card mb-1" id="shippingsCard">
			<div class="card-header">
				<div class="row flex-between-center">
					<div class="col-sm-auto d-flex align-items-center pe-0">
						<div class="row gy-2 gx-3 align-items-center">
							<div class="col-auto">
								<h5 class="fs-0 mb-0 text-nowrap py-2 py-xl-0">Ordenes de Pedido</h5>
							</div>
							<div class="col-auto">
								<div class="input-group">
									<input class="form-control form-control-sm shadow-none search" type="search"
										placeholder="" aria-label="search" ref="searchOrders"
										@keyup.enter="getOrderListLocal(1)" @focus="$event.target.select()">
									<div class="input-group-text bg-transparent pointer" @click="getOrderListLocal(1)">
										<span class="fa fa-search fs--1 text-600"></span>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="col-8 col-sm-auto ms-auto text-end ps-0">
						<div id="orders-actions">
							<button class="btn btn-falcon-default btn-sm me-2" type="button"
								@click="showOrderListLocal(0)" ref="btnShowOrderList">
								<span class="fas fa-plus" data-fa-transform="shrink-3 down-2"></span>
								<span class="d-none d-sm-inline-block ms-1">Nuevo</span>
							</button>
						</div>
					</div>
				</div>
			</div>
			<div class="card-body p-0">
				<div class="table-responsive scrollbar">
					<table class="table table-sm table-striped fs--1 mb-0 overflow-hidden table-hover">
						<thead class="bg-200">
							<tr>
								<th class="text-900 text-center">Columna 1</th>
								<th class="text-900">Columna 2</th>
							</tr>
						</thead>
					</table>
				</div>
			</div>
			<div class="card-footer">
				<div class="d-flex align-items-center justify-content-center">
					<pagination :pagination="paginationOrders" @getAllList="getAllOrders">
					</pagination>
				</div>
			</div>
		</div>
		<order-component></order-component>
	</div>
</template>

<script>
import mixin from '@/mixins'
import axiosAction from '@/mixins/axiosAction.js'
import errors from '@/mixins/errors.js'
import orders from '@/mixins/orders'

import Pagination from '@/components/Pagination.vue'
import MessageLoadingComponent from '@/components/MessageLoadingComponent.vue'
import OrderComponent from '@/components/OrderComponent.vue'

export default {
	name: 'OrderList',
	mixins: [mixin, axiosAction, errors, orders],
	props: [],
	data() {
		return {
		}
	},
	components: {
		'order-component': OrderComponent,
		'pagination': Pagination,
		'mensagge-loading-component': MessageLoadingComponent
	},
	computed: {
	},
	methods: {
		axiosResultLocal(responseLocal, response) {
			switch (responseLocal) {
				case 'getAllOrdersResult': this.getAllOrdersResult(response); break;
				default: console.log('Acción no determinada despues de la consulta (' + responseLocal + ')', this.$options.name); break;
			}
		},
		getAllOrdersLocal(page = 1) {
			this.getAllOrders()
		},
		getAllOrdersResultLocal(response) { },
		initModuleLocal() {
			this.setOrderInit()
		},
		setOrderInitLocal() {
			this.getAllOrdersLocal()
		},
		showOrderListLocal() { },
	},
	mounted() {
		this.initModule(this.$options.name)
	},
}
</script>